'use client';

import { useEffect } from 'react';
import { install } from '@crehana/devtools';
export var Devtools = function Devtools() {
  useEffect(function () {
    install();
  }, []);
  return null;
};